// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './projects-api';

export const useListProjects: typeof hookExports.useListProjects = hookExports.useListProjects;
export const useLazyListProjects: typeof hookExports.useLazyListProjects =
  hookExports.useLazyListProjects;
